import { ReactComponent as Trash } from '../Assets/Icons/trashcan.svg';
import * as Tooltip from '@radix-ui/react-tooltip';
import { ReactComponent as ExclamationMark } from '../Assets/Icons/exclamation-mark.svg';
import { IconButton, IconButtonProps } from '../SubComponents/Buttons';
import styled from 'styled-components/macro';
import { Label } from '../SubComponents/Text';
import useTypeSafeLocalize from '../Hooks/use-type-safe-localize';
import { ErrorLocalization, LocalizationCategory } from '../localizations/types';
import useRemoveCancellationProtection from 'Hooks/use-remove-cancellation-protection';
export interface RemoveItemButtonProps {
  itemId: string;
}
const TooltipContent = styled(Tooltip.Content)`
  padding: 10px 15px;
  background: white;
  border-radius: 8px;
`;

const RemoveCancellationWarrantyButton = () => {
  const localize = useTypeSafeLocalize();
  const { loading, removeCancellationProtection, error } =
    useRemoveCancellationProtection();

  const iconButtonProps: IconButtonProps = {
    onClick: removeCancellationProtection,
    icon: error ? ExclamationMark : Trash,
    width: '11px',
    height: '17px',
    pt: '1px',
    mr: '2',
    disabled: loading,
    loading: loading,
  };

  return error ? (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <span>
          <IconButton {...iconButtonProps} />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <TooltipContent>
          <Label error>
            {localize(LocalizationCategory.error, ErrorLocalization.UnknownError)}
          </Label>
        </TooltipContent>
      </Tooltip.Portal>
    </Tooltip.Root>
  ) : (
    <IconButton {...iconButtonProps} />
  );
};

export default RemoveCancellationWarrantyButton;
